import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';

const PossibleMatch = (match) => {
  if (resolve(match, 'params/target', false)) {
    return `match(target_id:${Number(resolve(match, 'params/target', null))}),`;
  }
  return '';
};

const employeesQuery =  (params={}) => {
  const employeeSortParams = jsonToInputParams({
    sort_by: params.sort_by,
    sort_order: params.sort_order,
    limit: resolve(params, 'limit', 15),
    has_surveyed: resolve(params, 'surveyed', true)
  });
  return HiringQuery(`
  {
    organization {
      id
    }
    opening (id: ${params.match.params.id}) {
      name,
      closed,
      employees:
        users (${employeeSortParams}) {
          pagination {
            total,
            limit,
            offset
          }
          results {
            first_name,
            last_name,
            id,
            ${PossibleMatch(resolve(params, 'match', {}))}
            assessment (completed: true) {
              id,
              validity_score,
              validity_errors,
              scored
            }
          }
        }
      }
    }
  `);
};

const employeesParseQuery = (data) => ({
  employees: resolve(data, 'opening/employees/results', []),
  users: {
    pagination: resolve(data, 'opening/employees/pagination', {total:0}),
    results: resolve(data, 'opening/employees/results', []).map(r=>({
      survey_date: resolve(r, 'survey/date', ''),
      name: resolve(r, 'name', ''),
      email: resolve(r, 'email', {}),
      survey_status: resolve(r, 'survey/status', 'Pending'),
      view: `/hiring/employee/${resolve(r, 'id')}`
    }))
  }
});

export { employeesQuery, employeesParseQuery };
